import React, {
  createContext,
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import Api from '../../util/api';
import useConfig from '../../util/useConfig';

const EventContext = createContext(null);

const EventState = ({ children }) => {
  const [questions, setQuestions] = useState([]);
  const [pickedQuestionId, setPickedQuestionId] = useState('');
  const [pickedQuestions, setPickedQuestions] = useState([]);
  const [eventId, setEventId] = useState(null);
  const { id } = useConfig();

  // Read via a ref rather than closing over `questions` directly, since this
  // callback is memoized once (stable identity for the mount effect below)
  // and a stale closure would always see the initial empty array.
  const questionsRef = useRef(questions);
  questionsRef.current = questions;

  const fetchQuestions = useCallback(
    (force = false) => {
      if (!force && questionsRef.current.length > 0) {
        return;
      }
      Api.questions.fetchSharedQuestions(id).then(({ data }) => {
        setQuestions(data);
      });
    },
    [id]
  );

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  const memoizedState = useMemo(
    () => ({
      questions,
      pickedQuestions,
      setPickedQuestions,
      fetchQuestions,
      eventId,
      setEventId,
      pickedQuestionId,
      setPickedQuestionId,
    }),
    [
      questions,
      pickedQuestions,
      fetchQuestions,
      setPickedQuestions,
      eventId,
      setEventId,
      pickedQuestionId,
      setPickedQuestionId,
    ]
  );

  return (
    <EventContext.Provider value={memoizedState}>
      {children}
    </EventContext.Provider>
  );
};
export { EventState, EventContext };
